export default function () {
    return {
        KEYS: {
            ACTIVE: 'ACTIVE',
            INACTIVE: 'INACTIVE'
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/notification/translation/status/index.js